module.exports = __webpack_public_path__ + "static/p-indra-0a5b8b98d2661932b3d0010f91137535.jpg";